export default function RouteLoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8f9fa]">
      <i className="ri-loader-4-line text-3xl text-primary animate-spin" />
    </div>
  );
}
